import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Container, TextField, Button, Typography, Grid, Paper, Accordion, AccordionSummary, AccordionDetails, Snackbar, Alert, IconButton, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import config from '../config/config'; // Import configuration

const ProjectTeams = ({ projectId, projectName }) => {
  const [projectTeams, setProjectTeams] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProjectTeam, setSelectedProjectTeam] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const editSectionRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    fetchProjectTeams();
  }, [projectId]);

  const fetchProjectTeams = async () => {
    try {
      
      const token = localStorage.getItem('authToken');
      console.log('Project Id in Teams:', projectId);
      const response = await axios.get(`${config.apiBaseUrl}/api/project-teams/project/${projectId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-TenantID': 'admin',
        },
      });
      console.log('Project in Teams:', response.data);
      const filteredTeams = response.data;
      console.log('Filtered Project in Teams:', filteredTeams);
      setProjectTeams(filteredTeams);
      if (filteredTeams.length > 0) {
        setSelectedProjectTeam(filteredTeams[0]);
      }
    } catch (error) {
      console.error('Error fetching project teams:', error);
      setSnackbar({ open: true, message: 'Failed to fetch project teams', severity: 'error' });
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (gridApi) {
      gridApi.setGridOption('quickFilterText', event.target.value);
    }
  };

  

  const handleRowClick = (event) => {
    const projectTeam = event.data;
    console.log('Selected Project Team (Row Click):', projectTeam); // Log the selected project team
    setSelectedProjectTeam(projectTeam);
    setTimeout(() => {
      editSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  
    setSelectedProjectTeam((prev) => {
      // Check if the field belongs to the `teamMember` object
      if (name in prev.teamMember) {
        return {
          ...prev,
          teamMember: {
            ...prev.teamMember,
            [name]: value, // Update the specific field in `teamMember`
          },
        };
      }
  
      // Otherwise, update the field directly in the root object
      return {
        ...prev,
        [name]: value,
      };
    });
  
    console.log('Updated Project Team (Input Change):', selectedProjectTeam.data); // Log the updated project team
  };

  const handleDateChange = (name, date) => {
    setSelectedProjectTeam({ ...selectedProjectTeam, [name]: date });
  };

  const handleSave = async () => {
    try {
      console.log('selected proj team' , selectedProjectTeam.data);
      const token = localStorage.getItem('authToken');
      const payload = {
        
        projectTeamId: selectedProjectTeam.projectTeamId,
        project: selectedProjectTeam.project,
        teamMember: {
          teamMemberId: selectedProjectTeam.teamMember.teamMemberId,
          teamMemberName: selectedProjectTeam.teamMember.teamMemberName,
          role: selectedProjectTeam.teamMember.role,
          contactInfo: selectedProjectTeam.teamMember.contactInfo,
          phoneNo: selectedProjectTeam.teamMember.phoneNo,
          emailId: selectedProjectTeam.teamMember.emailId,
          expertise: selectedProjectTeam.teamMember.expertise,
          relievingDate: selectedProjectTeam.teamMember.relievingDate,
          department: selectedProjectTeam.teamMember.department,
          company: selectedProjectTeam.teamMember.company,
          createdAt: selectedProjectTeam.teamMember.createdAt,
          updatedAt: selectedProjectTeam.teamMember.updatedAt,
        },
        assignedDate: selectedProjectTeam.assignedDate,
        company: selectedProjectTeam.company,
        teamName: selectedProjectTeam.teamName,
        description: selectedProjectTeam.description,
      };
  
      console.log('Payload:', payload); // Debugging log
  
      if (selectedProjectTeam.projectTeamId) {
        // Update existing project team
        await axios.put(
          `${config.apiBaseUrl}/api/project-teams/${selectedProjectTeam.projectTeamId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'X-TenantID': 'admin',
            },
          }
        );
      } else {
        // Create new project team
        await axios.post(`${config.apiBaseUrl}/api/project-teams`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-TenantID': 'admin',
          },
        });
      }
  
      setSnackbar({ open: true, message: 'Project team saved successfully', severity: 'success' });
      fetchProjectTeams(); // Refresh the data
    } catch (error) {
      console.error('Error saving project team:', error.response?.data || error.message);
      setSnackbar({ open: true, message: 'Failed to save project team', severity: 'error' });
    }
  };

  const handleNewProjectTeam = () => {
    const newProjectTeam = {
      projectTeamId: null,
      project: {
        project_id: projectId,
        company_id: {
          companyId: '',
          companyName: '',
        },
        project_name: projectName,
        start_date: null,
        planned_completion_date: null,
        actual_completion_date: null,
        status: '',
        estimated_cost: '',
        actual_cost: '',
        description: '',
        project_manager: '',
        client_name: '',
        priority: '',
        risk_level: '',
        budget: '',
        actual_hours: '',
        estimated_hours: '',
        milestones: '',
        deliverables: '',
        location_id: {
          id: '',
          locationName: '',
        },
      },
      teamMember: {
        teamMemberId: '',
        teamMemberName: '',
        role: '',
        contactInfo: '',
        phoneNo: '',
        emailId: '',
        expertise: '',
        relievingDate: null,
        department: '',
        company: '',
      },
      assignedDate: null,
      company: '',
      teamName: '',
      description: '',
    };
    console.log('New Project Team:', newProjectTeam); // Log the new project team
    setSelectedProjectTeam(newProjectTeam);
  };

  const handleDeleteProjectTeam = async () => {
    try {
      const token = localStorage.getItem('authToken');
      await axios.delete(`${config.apiBaseUrl}/api/project-teams/${selectedProjectTeam.projectTeamId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-TenantID': 'admin',
        },
      });
      setSnackbar({ open: true, message: 'Project team deleted successfully', severity: 'success' });
      fetchProjectTeams();
      setSelectedProjectTeam(null);
    } catch (error) {
      console.error('Error deleting project team:', error);
      setSnackbar({ open: true, message: 'Failed to delete project team', severity: 'error' });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    if (params.api.getDisplayedRowCount() > 0) {
      const firstRow = params.api.getDisplayedRowAtIndex(0);
      params.api.selectNode(firstRow, true);
      setSelectedProjectTeam(firstRow.data);
      setTimeout(() => {
        editSectionRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const columnDefs = [
    { headerName: 'Project Name', field: 'project.project_name', sortable: true, filter: true },
    { headerName: 'Team Member Name', field: 'teamMember.teamMemberName', sortable: true, filter: true },
    { headerName: 'Email Id', field: 'teamMember.emailId', sortable: true, filter: true },
    { headerName: 'Phone No', field: 'teamMember.phoneNo', sortable: true, filter: true },
    { headerName: 'Contact Info', field: 'teamMember.contactInfo', sortable: true, filter: true },
    { headerName: 'Role', field: 'teamMember.role', sortable: true, filter: true },
   ];

  const defaultColDef = {
    flex: 1,
    minWidth: 150,
    filter: true,
    sortable: true,
    resizable: true,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <TextField
            label="Search Project Teams"
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            fullWidth
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ padding: 2 }}>
              <Box className="ag-theme-alpine" sx={{ height: 400, width: '100%' }}>
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={projectTeams}
                  pagination={true}
                  paginationPageSize={10}
                  onRowClicked={handleRowClick}
                  onGridReady={onGridReady}
                  defaultColDef={defaultColDef}
                  rowSelection="single"
                />
              </Box>
            </Paper>
          </Grid>
          {selectedProjectTeam && (
            <Grid item xs={12}>
              <Accordion expanded ref={editSectionRef} sx={{ marginTop: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Edit Project Team</Typography>
                  <Box ml={2}>
                    <Button variant="contained" color="primary" onClick={handleSave} sx={{ marginRight: 1 }}>
                      Save
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleDeleteProjectTeam} sx={{ marginRight: 1 }}>
                      Delete
                    </Button>
                    <Button variant="contained" color="default" onClick={handleNewProjectTeam}>
                      New
                    </Button>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Project Name"
                        variant="outlined"
                        fullWidth
                        name="project_name"
                        value={selectedProjectTeam.project.project_name}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField
                      label="Project Name"
                      variant="outlined"
                      fullWidth
                      name="project_name"
                      value={selectedProjectTeam.project.project_name || ""} // Fallback to empty string
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Team Member Name"
                      variant="outlined"
                      fullWidth
                      name="teamMemberName"
                      value={selectedProjectTeam.teamMember.teamMemberName || ""} // Fallback to empty string
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Email Id"
                      variant="outlined"
                      fullWidth
                      name="emailId"
                      value={selectedProjectTeam.teamMember.emailId || ""} // Fallback to empty string
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Phone No"
                      variant="outlined"
                      fullWidth
                      name="phoneNo"
                      value={selectedProjectTeam.teamMember.phoneNo || ""} // Fallback to empty string
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Contact Info"
                      variant="outlined"
                      fullWidth
                      name="contactInfo" // Matches the key in `teamMember`
                      value={selectedProjectTeam.teamMember.contactInfo || ""}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Role"
                      variant="outlined"
                      fullWidth
                      name="role"
                      value={selectedProjectTeam.teamMember.role || ""} // Fallback to empty string
                      onChange={handleInputChange}
                    />
                  </Grid>



                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
        </Grid>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default ProjectTeams;